<template>
  <div class="edit-box-p">
    <h3>
      <slot name="title"></slot>
    </h3>
    <div class="main-form-p" v-for="(item1,index1) of formList" :key="item1.type+index1">
      <div class="text-edit-p" v-if="item1.type=='text'">
        <textarea placeholder="正文内容......" v-model="item1.content"></textarea>
      </div>
      <div class="img-edit-p" v-if="item1.type=='img'">
        <image-upload :src="src1" @getDataArr="getDataArr1($event,index1)">
          <i slot="del" class="del-p"></i>
        </image-upload>
      </div>
      <div class="node-edit-p" v-if="item1.type=='node'">
        <div class="node-title">
          <input type="text" placeholder="请输入节点名称" v-model="item1.content.nodeName" />
        </div>
        <div class="node-content">
          <textarea placeholder="请输入正文内容" v-model="item1.content.remark"></textarea>
        </div>
        <div class="node-img">
          <image-upload :src="src2" @getDataArr="getDataArr2($event,index1)">
            <i slot="del" class="del-p"></i>
          </image-upload>
        </div>
        <div class="node-state">
          <div>
            <span>本节点状态：</span>
          </div>
          <div
            class="item-state"
            v-for="(item2,index2) of item1.content.nodeList"
            :key="item2.text"
            @click="selectState(index1,index2)"
          >
            <img :src="item2.selected ? stateSrcActive : stateSrc" alt />
            <span>{{item2.text}}</span>
          </div>
        </div>
      </div>
    </div>

    <score-table v-model="value" v-show="scoreTableIsShow"/>

    <score-form ref="scoreForm" v-model="value" @scoreTableShow="scoreTableShow"/>

    <div class="add-content-p">
      <h3>
        <span>您可以选择以下内容添加</span>
        <img src="../../../../../html/pages/originality/createQe/images/arrow.png" alt />
      </h3>
      <div class="img-box-p">
        <img
          @click="add(1)"
          src="../../../../../html/pages/originality/createQe/images/upload_text.jpg"
          alt
        />
        <img
          @click="add(2)"
          src="../../../../../html/pages/originality/createQe/images/upload_img.jpg"
          alt
        />
        <img v-if="title != '材料'"
          @click="add(3)"
          src="../../../../../html/pages/originality/createQe/images/upload_node.jpg"
          alt
        />
        <img
          @click="add(4)"
          src="../../../../../html/pages/originality/createQe/images/upload_score.jpg"
          alt
        />
      </div>
    </div>
  </div>
</template>

<script>
import "../../../../../html/components/createQE/editBox.scss"

import ImageUpload from "../../../../../components/imageUpload/ImageUpload"
import scoreForm from "./scoreForm"
import scoreTable from "./scoreTable"

export default {
  name: 'editBox',
  data() {
    return {
      src1: require("../../../../../html/pages/originality/createQe/images/upload2.jpg"),
      src2: require("../../../../../html/pages/originality/createQe/images/upload1.jpg"),
      stateSrc: require("../../../../../html/pages/originality/createQe/images/sel.png"),
      stateSrcActive: require("../../../../../html/pages/originality/createQe/images/selActive.png"),
      formList: [
        { type: "text", content: "" }
      ],
      scoreTableIsShow: false
    }
  },
  components: {
    ImageUpload,
    scoreForm,
    scoreTable
  },
  props:{
    title:String,
    value:{
      type:Array,
      default(){
        return[]
      }
    }
  },
  methods: {
    getDataArr1($event, index) {
      this.formList[index].content = $event;
    },
    getDataArr2($event, index) {
      this.formList[index].content.img = $event;
    },
    selectState(index1, index2) {
      this.formList[index1].content.nodeList.forEach((item, i) => {
        if (i == index2) {
          item.selected = !item.selected
        } else {
          if (item.selected) {
            item.selected = false
          }
        }
      })
      for (let i = 0; i < this.formList[index1].content.nodeList.length; i++) {
        if (this.formList[index1].content.nodeList[i].selected == true) {
          this.formList[index1].content.nodeState = i+1;
          return
        }
      }
    },
    add(i) {
      switch (i) {
        case 1:
          this.formList.push({ type: "text", content: "" })
          break;
        case 2:
          this.formList.push({ type: "img", content: "" })
          break
        case 3:
          this.formList.push({
            type: "node",
            content: {
              nodeName: "",
              remark: "",
              img: [],
              nodeList: [
                { text: "良好", selected: false },
                { text: "预警", selected: false },
                { text: "异常", selected: false },
              ],
              nodeState: ""
            }
          })
          break
        case 4:
          this.$refs.scoreForm.toggle()
      }
    },
    scoreTableShow(){
     this.scoreTableIsShow = !this.value.every(item => {
        return item.score === ""
      })
    }
  },
}
</script>